module.exports = __webpack_public_path__ + "public/img/03.83c06c82.jpg";